import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint implicit-arrow-linebreak: 0 */

import _uniqueId from 'lodash/uniqueId';
import _find from 'lodash/find';
import _curry from 'lodash/curry';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _every from 'lodash/every';

// Readers
import filterGroupReader from '../../readers/FilterGroup';
export var getUniqueFieldId = function getUniqueFieldId() {
  return _uniqueId('filterRow_');
};
var isFilterGroupSelected = _curry(function (selectedFilterGroupId, filterGroup) {
  var filterGroupId = filterGroupReader.id(filterGroup);
  return filterGroupId === selectedFilterGroupId;
});
export var getSelectedFilterGroup = function getSelectedFilterGroup(selectedFilterGroupId, filterGroups) {
  return _find(filterGroups, isFilterGroupSelected(selectedFilterGroupId));
};
var matchesGroupFilter = _curry(function (groupFilter, selectedFilter) {
  return selectedFilter.type === groupFilter.type;
});
var mergeSelectedFiltersWithGroupFilters = _curry(function (selectedFilters, groupFilter) {
  var selectedGroupFilter = _find(selectedFilters, matchesGroupFilter(groupFilter));
  if (!selectedGroupFilter) {
    return groupFilter;
  }
  return _objectSpread(_objectSpread({}, groupFilter), selectedGroupFilter);
});
var isNotPartOfGroupFilter = _curry(function (groupFilters, selectedFilter) {
  return _every(groupFilters, function (groupFilter) {
    return groupFilter.type !== selectedFilter.type;
  });
});
export var getMergedFilters = function getMergedFilters(selectedGroupFilters, selectedFilters) {
  var mergedSelectedFilters = _map(selectedGroupFilters, mergeSelectedFiltersWithGroupFilters(selectedFilters));
  var selectedFiltesNotInGroup = _filter(selectedFilters, isNotPartOfGroupFilter(selectedGroupFilters));
  return [].concat(_toConsumableArray(mergedSelectedFilters), _toConsumableArray(selectedFiltesNotInGroup));
};